import React, { useContext, useEffect, useState } from 'react'
import './settings.css'
import Tabs from '../../components/tabs/tabs'
import { PageHeader } from '../../layouts/header/page-header'
import UploadStatus from './upload_documents/upload_status'
import UploadDocuments from './upload_documents/upload_documents'
import { UserManagement } from './usermanagement/usermanagement'
const Settings = (props:any) => {
  const [ tabItems, setTabItems ] = useState<any>()
  const [activeTab, setActiveTab ] = useState<number>(0)
  useEffect(() => {
    setTabItems([
      {
        tabtitle: 'Upload Files',
        is_active: activeTab === 0,
        content: (<><UploadDocuments/></>)
      },
      {
        tabtitle: 'User Management',
        is_active: activeTab === 1,
        content: (<><UserManagement/></>)
      },
    ])
  }, [activeTab])
  return (
        <>
            <PageHeader name='Settings' icon="icon-settings"/>
            <div className='container'>
                <div className='row m-0'>
                    <Tabs items={tabItems} page='settings' setActiveTab={(index: any) => { setActiveTab(index) }} tabsul="overflow-auto" className="latobold darktext mb-2 px-2 pt-2" anchorclass="segoeui-regular font-16" mainTabsclass="m-0"/>
                </div>
            </div>
        </>
  )
}
export default Settings
